import React, { useEffect } from 'react';

import ConsumerLayout from '../../../consumer-page/consumer-layout/ConsumerLayout';
import RecreateImagesHeader from './header/RecreateImagesHeader';
import RecreateFilters from './filters/RecreateFilters';
import RecreateOutput from './output/RecreateOutput';
import ReloadController from './reload-controller/ReloadController';
import ImagesGeneratingStatusController from './output/loader-controller/DemoLoaderController';
import NoAttemptsErrorController from '../no-attempts-modal/NoAttemptsErrorController';
import { clearId8ImageCaches } from '../../../utils/clearId8ImageCaches';

function RecreateImages() {
  useEffect(() => {
    return () => {
      clearId8ImageCaches();
    };
  }, []);

  return (
    <ConsumerLayout Header={RecreateImagesHeader()}>
      <RecreateFilters />

      <RecreateOutput />

      <ReloadController />
      <NoAttemptsErrorController />
      <ImagesGeneratingStatusController generationLabel='recreateImagesInProgress' />
    </ConsumerLayout>
  );
}

export default RecreateImages;
